// extracted by mini-css-extract-plugin
export var content = "Hero-module--content--e5c84";
export var contentFullWidth = "Hero-module--contentFullWidth--b84e2";
export var control = "Hero-module--control--3a7cd";
export var image = "Hero-module--image--81156";
export var inner = "Hero-module--inner--586a7";
export var sottotitolo = "Hero-module--sottotitolo--d9507";
export var title = "Hero-module--title--a0049";